<template>
  <div class="dft-title_text">
    <div class="attr-item-box" v-for="(item,index) in value" :key="index">
      <div class="attr-item-typedata" v-if="item.type == 'data'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div class="attr-item-value">
          <el-input v-if="item.tag == 'input'" v-model="item.value"></el-input>
          <el-input v-else-if="item.tag == 'textarea'" type="textarea" v-model="item.value"></el-input>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item.type == 'style'">
        <div class="attr-item-label">{{ item.label }}</div>
        <div v-if="item.showList" class="attr-item-on">{{ item.showList[item.value] || item.value }}</div>
        <div class="attr-item-value">
          <!-- >>>标题文本 -->
          <el-radio-group v-if="item.sid == 'titleText_s1'" v-model="item.value" size="small">
            <el-radio-button label="left">居左显示</el-radio-button>
            <el-radio-button label="center">居中显示</el-radio-button>
          </el-radio-group>
          <el-radio-group v-else-if="item.sid == 'titleText_s2'" v-model="item.value" size="small">
            <el-radio-button label="16px"><span style="font-size: 16px;">A</span></el-radio-button>
            <el-radio-button label="14px"><span style="font-size: 14px;">A</span></el-radio-button>
            <el-radio-button label="12px"><span style="font-size: 12px;">A</span></el-radio-button>
          </el-radio-group>
          <el-radio-group v-else-if="item.sid == 'titleText_s3'" v-model="item.value" size="small">
            <el-radio-button label="400"><span style="font-weight: 400;">T</span></el-radio-button>
            <el-radio-button label="600"><span style="font-weight: 600;">T</span></el-radio-button>
          </el-radio-group>
          <div v-else-if="item.sid == 'titleText_s4'" class="colorPicker">
            <el-button type="text" @click="item.value = item.default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="item.value" show-alpha></el-color-picker>
          </div>
          <el-checkbox v-else-if="item.sid == 'titleText_s5'" v-model="item.value" true-label="1" false-label="0"></el-checkbox>
          <!-- 标题文本<<< -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
        type: Array,
        default: ()=>[]
    },
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
        [
          { label: '标题内容', value: '标题内容', key: 'title', type: 'data', tag: 'input'},//0
          { label: '描述内容', value: '描述内容', key: 'subtitle', type: 'data', tag: 'textarea'},
          { 
            label: '显示位置', value: 'left', sid:'titleText_s1',
            showList: {
              'left':'居左显示',
              'center':'居中显示'
            },
            key: 'text-align', type: 'style', tag: 'radio'},
          { 
            label: '标题大小', value: '16px', sid:'titleText_s2',
            showList: {
              '16px':'大（16号）',
              '14px':'中（14号）',
              '12px':'小（12号）'
            },
            key: 'font-size', type: 'style', tag: 'radio'
          },
          { 
            label: '描述大小', value: '12px', sid:'titleText_s2',
            showList: {
              '16px':'大（16号）',
              '14px':'中（14号）',
              '12px':'小（12号）'
            },
            key: 'font-size', type: 'style', tag: 'radio'
          },
          { 
            label: '标题粗细', value: '600', sid:'titleText_s3',
            showList: {
              '400':'常规',
              '600':'加粗',
            },
            key: 'font-weight', type: 'style', tag: 'radio'
          },
          { 
            label: '描述粗细', value: '400', sid:'titleText_s3',
            showList: {
              '400':'常规',
              '600':'加粗',
            },
            key: 'font-weight', type: 'style', tag: 'radio'
          },//6
          { 
            label: '标题颜色', value: '#323233', sid:'titleText_s4',
            showList: {},default:'#323233',
            key: 'color', type: 'style', tag: 'ColorPicker'
          },//7
          { 
            label: '描述颜色', value: '#969799', sid:'titleText_s4',
            showList: {},default:'#969799',
            key: 'color', type: 'style', tag: 'ColorPicker'
          },//8
          { 
            label: '背景颜色', value: '#ffffff', sid:'titleText_s4',
            showList: {},default:'#ffffff',
            key: 'background-color', type: 'style', tag: 'ColorPicker'
          },//9
          { 
            label: '底部分割线', value: '0', sid:'titleText_s5',
            showList: {
              '1':'显示',
              '0':'不显示'
            },
            key: 'border-bottom', type: 'style', tag: 'checkbox'
          },//10
          { 
            label: '查看更多', value: '0', sid:'titleText_s5',
            showList: {
              '1':'显示',
              '0':'不显示'
            },
            key: 'more', type: 'style', tag: 'checkbox'
          },//11
        ]
      )
    };
  },
  watch:{
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });
          
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData(){
    },
  },
};
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.attr-item-box{
  padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    .attr-item-label{
      margin-bottom: 5px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              width: calc(100% - 80px);
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{}
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  
}

.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
</style>

